export const CATEGORY_LABELS: Record<string, string> = {
  title: 'Title',
  bullets: 'Bullets',
  description: 'Description',
  alexa_for_shopping: 'Alexa for Shopping'
};

export const TIER_LABELS: Record<number, string> = {
  1: 'Amazon Official',
  2: 'Verified Research',
  3: 'Practitioner'
};
